import { isMobile } from 'shared/util/utility';
import { FreeMode, Mousewheel, SwiperOptions } from 'swiper';
export const bannerSwiperConfig = (count: number): SwiperOptions => {
	return {
		slidesPerView: 'auto',
		modules: [FreeMode, Mousewheel],
		allowTouchMove: true,
		grabCursor: true,
		threshold: 5,
		spaceBetween: isMobile() ? 8 : 12,
		loop: count > 3,
		preventClicks: true,
	};
};
